import styled from 'styled-components'
import React from "react";
import RemoveFilterIcon from './RemoveFilterIcon'

const RemoveFilterButtonDiv = styled.div`
  height: 20px;
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
  margin-top: 7px;
`

const IconButtonWrapper = styled.div`
  padding: 2px 2px;
  cursor: pointer;
`

const RemoveFilterButton = () => (
    <RemoveFilterButtonDiv >
      <IconButtonWrapper>
        <RemoveFilterIcon />
      </IconButtonWrapper>
    </RemoveFilterButtonDiv>
)

export default RemoveFilterButton
